import { CardContent, TextField } from "@mui/material";
import { Title, useNotify, useRedirect } from "react-admin";
import { useState } from "react";
import { DownloadButton } from "./analytics";
import { DateTime } from "luxon";
import { httpClient } from "./dataProvider";
import { Button } from "@mui/material";

export const StartExportButton = (props: { url?: string; data?: any }) => {
    const notify = useNotify();
    const redirect = useRedirect();
    const [processing, setProcessing] = useState(false);

    const disabled = props.url === undefined;

    const onDownload = () => {
        if (props.url === undefined) {
            return;
        }

        setProcessing(true);

        const body = JSON.stringify(props.data);
        console.log(body);

        httpClient(props.url, { method: "POST", body: body })
            .then((response) => {
                redirect(`/exports/${response.json.export_id}/show`);
                setProcessing(false);
            })
            .catch((error) => {
                notify(error.toString(), { type: "error" });
                setProcessing(false);
            });
    };

    return (
        <Button disabled={disabled || processing} onClick={onDownload} variant="contained" color="primary">
            Download CSV
        </Button>
    );
};

export const DistributorReportingPage = () => {
    const [startMonth, setStartMonth] = useState<string | null>(null);
    const [endMonth, setEndMonth] = useState<string | null>(null);
    let artistDownloadUrl = import.meta.env.VITE_SERVER_URL + "/analytics/distributor_reporting";

    let reportingBody = null;

    if (startMonth !== null && endMonth !== null) {
        reportingBody = { start_month: startMonth, end_month: endMonth };
    }

    let trackStatUrl = import.meta.env.VITE_SERVER_URL + "/analytics/track_stats";

    const handleStartMonthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setStartMonth(event.target.value);
    };

    const handleEndMonthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEndMonth(event.target.value);
    };

    return (
        <div>
            <Title title="Analytics" />
            <CardContent>
                <h1>Distributor reporting</h1>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        marginBottom: "20px",
                        alignItems: "start",
                        marginTop: "20px",
                    }}
                >
                    <TextField
                        label="Start Month"
                        type="month"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={startMonth || ""}
                        onChange={handleStartMonthChange}
                    />
                    <TextField
                        label="End Month (inclusive)"
                        type="month"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={endMonth || ""}
                        onChange={handleEndMonthChange}
                    />
                    <StartExportButton url={artistDownloadUrl} data={reportingBody} />
                    <a href="https://developer.audiomob.com/dashboard/reporting/custom" target="_blank">
                        Go to AudioMob report
                    </a>
                    <a
                        href="https://dash.applovin.com/o/mediation/report?r=3#rsid=a65791abfa6962537e82e57bbc3da7f20c37d21d"
                        target="_blank"
                    >
                        Go to AppLovin report
                    </a>
                </div>
                <h1>Track stats</h1>
                <StartExportButton url={trackStatUrl} />
            </CardContent>
        </div>
    );
};
